/* Sharp product zoom fix — upgrades Shopify CDN sources for hover zoom + lightbox */
(function () {
  'use strict';

  var MAX_W = 5760;                                   // Shopify hard cap
  var DPR = Math.min(window.devicePixelRatio || 1, 3);
  var HOVER_W = Math.min(Math.round(1800 * DPR), MAX_W);
  var LIGHTBOX_W = Math.min(Math.round(2400 * DPR), MAX_W);

  var SIZE_SUFFIX =
    /_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(_crop_(top|center|bottom|left|right))?(?=\.(png|jpe?g|webp|gif|avif)(\.(png|jpe?g|webp)|$))/i;

  function isShopifyCdn(href) {
    return /cdn\.shopify\.com|\/cdn\/shop\/|\/cdn\/shopifycloud\//.test(href);
  }

  function upscale(url, width) {
    if (!url) return url;
    try {
      var u = new URL(url, window.location.origin);
      if (!isShopifyCdn(u.href)) return url;
      u.pathname = u.pathname.replace(SIZE_SUFFIX, '');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      u.searchParams.set('width', width);
      return u.href;
    } catch (e) {
      return url;
    }
  }

  function currentSrc(img) {
    return img.currentSrc || img.src || img.getAttribute('data-src') || '';
  }

  /* Swap an <img> to a high-res source, only after it has decoded, to avoid flicker */
  function upgradeImg(img, width) {
    if (!img || img.dataset.zoomUpgraded === String(width)) return;
    var src = currentSrc(img);
    if (!isShopifyCdn(src)) return;

    var hi = upscale(src, width);
    if (hi === src) return;

    img.dataset.zoomUpgraded = String(width);

    var pre = new Image();
    pre.decoding = 'async';
    pre.onload = function () {
      img.removeAttribute('srcset');   // stop the browser re-picking a small candidate
      img.removeAttribute('sizes');
      img.removeAttribute('data-srcset');
      img.src = hi;
      img.classList.add('loaded', 'is-loaded', 'lazyloaded');
    };
    pre.src = hi;
  }

  /* Background-image zoom lenses / result panes */
  function upgradeBackground(el, width) {
    if (!el || el.dataset.zoomBgUpgraded === String(width)) return;
    var bg = el.style.backgroundImage || getComputedStyle(el).backgroundImage;
    var m = bg && bg.match(/url\(["']?(.*?)["']?\)/);
    if (!m || !isShopifyCdn(m[1])) return;

    var hi = upscale(m[1], width);
    if (hi === m[1]) return;

    el.dataset.zoomBgUpgraded = String(width);
    var pre = new Image();
    pre.onload = function () {
      el.style.backgroundImage = 'url("' + hi + '")';
    };
    pre.src = hi;
  }

  /* Data attributes consumed by lightbox / zoom libraries */
  var DATA_ATTRS = [
    'data-zoom', 'data-zoom-src', 'data-zoom-image', 'data-large',
    'data-large-image', 'data-large_image', 'data-full', 'data-image',
    'data-src-large', 'data-photoswipe-src', 'data-fancybox-src'
  ];

  function upgradeAttrs(el) {
    DATA_ATTRS.forEach(function (attr) {
      var v = el.getAttribute(attr);
      if (v && isShopifyCdn(v)) el.setAttribute(attr, upscale(v, LIGHTBOX_W));
    });
    var href = el.getAttribute('href');
    if (href && isShopifyCdn(href) && /\.(png|jpe?g|webp|avif)/i.test(href)) {
      el.setAttribute('href', upscale(href, LIGHTBOX_W));
    }
  }

  function prepare(root) {
    root.querySelectorAll('a[href], [data-zoom], [data-large], [data-image], [data-zoom-src]')
      .forEach(upgradeAttrs);
  }

  /* On first hover of a media area, upgrade every image inside it */
  function bindHover(root) {
    root.querySelectorAll(
      '[class*="media"], [class*="zoom"], .swiper-slide, xo-media, .product-media'
    ).forEach(function (wrap) {
      if (wrap.dataset.zoomHoverBound) return;
      wrap.dataset.zoomHoverBound = '1';
      var handler = function () {
        wrap.querySelectorAll('img').forEach(function (img) {
          upgradeImg(img, HOVER_W);
        });
        upgradeBackground(wrap, HOVER_W);
      };
      wrap.addEventListener('pointerenter', handler, { passive: true });
      wrap.addEventListener('touchstart', handler, { passive: true });
    });
  }

  /* Catch clones/lenses/lightboxes created after load */
  function observe() {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          var inLightbox = node.closest(
            '.pswp, .fancybox__container, [class*="lightbox"], [class*="popup"], dialog, .modal'
          );
          var w = inLightbox ? LIGHTBOX_W : HOVER_W;

          if (node.tagName === 'IMG') upgradeImg(node, w);
          node.querySelectorAll && node.querySelectorAll('img').forEach(function (i) {
            upgradeImg(i, w);
          });

          if (node.style && node.style.backgroundImage) upgradeBackground(node, w);
          node.querySelectorAll &&
            node.querySelectorAll('[style*="background-image"]').forEach(function (e) {
              upgradeBackground(e, w);
            });

          upgradeAttrs(node);
        });

        if (m.type === 'attributes' && m.target.style && m.target.style.backgroundImage) {
          var lb = m.target.closest('.pswp, .fancybox__container, [class*="lightbox"]');
          upgradeBackground(m.target, lb ? LIGHTBOX_W : HOVER_W);
        }
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'src']
    });
  }

  function init() {
    document.querySelectorAll('xo-product, [xo-product-information]').forEach(function (root) {
      prepare(root);
      bindHover(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); observe(); });
  } else {
    init();
    observe();
  }

  // Re-run after section re-render (variant change, Theme Editor)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', init);
  window.addEventListener('pageshow', init);
})();